import { ComponentCanDeactivate } from './../../guards/pending-changes.guard';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import { WalkingService } from "./../../services/walking.service";
import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import Swal from "sweetalert2/src/sweetalert2.js";
import { AchievementService } from "src/app/services/achievement.service";
import  moment from "moment";
import { TranslateService } from '@ngx-translate/core';
import { defineLocale, listLocales } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';


import { DigitLocaleService } from 'src/app/services/digit-locale.service';
import { hiLocale } from 'ngx-bootstrap/locale';
import { mrLocale } from 'src/app/i18n/mr';
defineLocale('hindi', hiLocale);
defineLocale('marathi', mrLocale);

@Component({
    selector: "app-add-walking-entry",
    templateUrl: "./add-walking-entry.component.html",
    styleUrls: ["./add-walking-entry.component.scss"],
    standalone: false
})
export class AddWalkingEntryComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild("form", { static: false }) entryForm?: NgForm;
  submitted = false;
  formProcessing = false;
  error?: string;
  maxDate = new Date();
  bsDate = new Date();

  constructor(
    private walkingService: WalkingService,
    private router: Router,
    private achievementService: AchievementService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private localeService: BsLocaleService,
    private digitLocaleService:DigitLocaleService
  ) {}

  ngOnInit(): void {
    // get the date if set
    this.route.queryParams.subscribe((params: any) => {
      if(params.d){
        this.bsDate = moment(params.d).toDate();
      } 
    });
    if(this.translate.currentLang == 'hindi'){
      this.localeService.use(this.translate.currentLang);
    }
    else if(this.translate.currentLang == 'marathi'){
      this.localeService.use(this.translate.currentLang);
    }
    else{
      this.localeService.use('en');
    }
  }

  onSubmit() {
    this.submitted = true;
    this.formProcessing = true;
/*
    // convert hindi / marathi characters
    if( this.entryForm?.value.minutes){
      this.entryForm.value.minutes = this.digitLocaleService.convertDigits(this.entryForm?.value.minutes, this.translate.currentLang, 'en');
    }
    if( this.entryForm?.value.seconds){
      this.entryForm.value.seconds = this.digitLocaleService.convertDigits(this.entryForm?.value.seconds, this.translate.currentLang, 'en');
    }
*/
if( !this.entryForm?.value.seconds){if(this.entryForm?.value){this.entryForm.value.seconds = '0';}}
    if (!this.entryForm?.valid) {
      Swal.fire({
        icon: "error",
        title: this.translate.instant("THIS FORM IS INVALID"),
        text: this.translate.instant("PLEASE CHECK THE FORM FOR ERRORS"),
        showConfirmButton: true,
      });
       this.formProcessing = false;
    } else {
      // create entry
      const resourceIds = [];
      this.walkingService
        .create(
          +this.entryForm?.value.minutes,
          +this.entryForm?.value.seconds,
          +this.entryForm?.value.difficulty,
          this.entryForm?.value.date
        )
        .subscribe(
          (responseData) => {
             this.formProcessing = false;
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: this.translate.instant("ENTRY CREATED"),
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              toast: true,
            });
            this.router.navigate(["/walking"]);
            this.entryForm?.reset();
            this.achievementService.refreshNotifications();
          },
          (error) => {
            this.error = error.message;
            this.formProcessing = false;
          }
        );
    }
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<any> | any {

    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away
    
    if(this.submitted){
      return true;
    }
    else if(!this.entryForm?.value.minutes && !this.entryForm?.value.seconds && !this.entryForm?.value.difficulty){
      return true;
    }
    else{
      return false;
    }
  }
}
